import VueBarcode from 'vue-barcode';
import moment from 'moment';
export default {
  name: 'trip-sheet-pdf',
  components: {'barcode': VueBarcode},
  props: ['tripsheetdata'],
  data () {
    return {
      tripdata:JSON.parse(JSON.stringify(this.tripsheetdata)),
      pickup:'Pickup',
      delivery:'Delivery',
    }
  },
  mounted () {
  },
  methods: {
    dateFormatforApptDate(date){
      return moment.utc(date).format("DD-MM-YYYY").valueOf();
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/TripSheetPdf/TripSheetPdf.js